import { render } from "./ContentsListArea.vue?vue&type=template&id=0c040b90&scoped=true"
import script from "./ContentsListArea.vue?vue&type=script&lang=js"
export * from "./ContentsListArea.vue?vue&type=script&lang=js"

import "./ContentsListArea.vue?vue&type=style&index=0&id=0c040b90&scoped=true&lang=stylus"

import exportComponent from "F:\\xampp\\htdocs\\GITLAB\\2026\\tokyo-shoseki\\R8-january\\08jk_sj1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c040b90"]])

export default __exports__